module.exports = __webpack_public_path__ + "c3868ddc4360babde067355c1b45ce9b.pdf";